import React, {useEffect, useRef, useState} from "react";
import {EventType} from "../../../apis";
import {useSessionEventListener} from "../hooks/useSessionEventListener";
import {useSessionState} from "../../pages/session/SessionStateContext";
import {useZoom} from "../../pages/session/ZoomContext";
import {Messages} from "./Messages";

interface Props {
    eventType: EventType;
    className?: string;
    placeholderJoin?: string;
    placeholderTextAppear?: string;
}

export function Stenographer({ eventType, className, placeholderJoin, placeholderTextAppear }: Props) {
    const { isSessionRunning } = useSessionState();
    const [zoom] = useZoom();
    const [values, setValues] = useState<string[]>([]);
    const contentRef = useRef<HTMLDivElement>(null);

    useSessionEventListener(eventType, async (data: string) => {
        setValues((prev) => [...prev, data]);
    });

    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = contentRef.current.scrollHeight;
        }
    }, [values, zoom]);

    if (!isSessionRunning && values.length === 0) {
        return (
            <div className="p-4">
                <div className="flex items-center justify-center h-full">
                    <p className="text-gray-500">{placeholderJoin ?? 'Start the session to begin translation'}</p>
                </div>
            </div>
        );
    }

    return (
        <Messages
            messages={values}
            ref={contentRef}
            className={className}
            zoom={zoom}
            placeholderTextAppear={placeholderTextAppear}
        />
    );
}
